import { fromZonedTime, toZonedTime } from "date-fns-tz";

const DEFAULT_TZ = "Africa/Abidjan";

/**
 * Build a UTC ISO string from a local calendar day + "HH:MM" interpreted in
 * the given IANA timezone (e.g. "Africa/Bamako"). This avoids the classic
 * `setHours/toISOString` bug where the browser's own timezone leaks into
 * what is meant to be a local appointment time in the country.
 */
export function buildIsoInTz(day: Date, time: string, timezone?: string): string {
  const [hh, mm] = time.split(":").map(Number);
  const yyyy = day.getFullYear();
  const mo = String(day.getMonth() + 1).padStart(2, "0");
  const dd = String(day.getDate()).padStart(2, "0");
  const local = `${yyyy}-${mo}-${dd}T${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}:00`;
  return fromZonedTime(local, timezone || DEFAULT_TZ).toISOString();
}

/**
 * Extract { day (midnight, browser-local Date wrapping the country day),
 * time "HH:MM" } from a UTC ISO string interpreted in the given IANA timezone.
 */
export function extractZonedDayTime(iso: string, timezone?: string): { day: Date; time: string } {
  const zoned = toZonedTime(new Date(iso), timezone || DEFAULT_TZ);
  const day = new Date(zoned.getFullYear(), zoned.getMonth(), zoned.getDate());
  const time = `${String(zoned.getHours()).padStart(2, "0")}:${String(zoned.getMinutes()).padStart(2, "0")}`;
  return { day, time };
}
